export default "__VITE_ASSET__391c6489__"